import { useEffect, useRef } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'

export default function AuthCallback() {
  const [params] = useSearchParams()
  const { completeLogin, user, error } = useAuth()
  const navigate = useNavigate()
  const started = useRef(false)

  useEffect(() => {
    const code = params.get('code')
    if (!code || started.current) return
    started.current = true
    completeLogin(code)
  }, [params, completeLogin])

  useEffect(() => {
    if (user) navigate('/', { replace: true })
  }, [user, navigate])

  if (error) {
    return (
      <div style={{ maxWidth: 420, margin: '80px auto', textAlign: 'center' }}>
        <p style={{ color: 'var(--danger)' }}>{error}</p>
        <button
          onClick={() => navigate('/')}
          style={{
            padding: '8px 16px',
            borderRadius: 8,
            background: 'var(--navy-900)',
            color: 'white',
            fontSize: 13.5,
            fontWeight: 600,
          }}
        >
          Back to sign-in
        </button>
      </div>
    )
  }

  return <p style={{ textAlign: 'center', marginTop: 80, color: 'var(--text-muted)' }}>Signing in…</p>
}
